<template>
    <a class="nav-main" href="#" id="feedbackTrigger"><i class="fa fa-flask"></i> {{ $t('navigation.feedback') }}</a>
</template>

<script>
    export default {
        name: "feedback-link",
        mounted() {
            window.ATL_JQ_PAGE_PROPS = {
                "triggerFunction": function(showCollectorDialog) {
                    jQuery("#feedbackTrigger").click(function(e) {
                        e.preventDefault();
                        showCollectorDialog();
                    });
                }
            };
        }
    }
</script>

<style scoped>

</style>
